var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btnBlock"},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button","name":"button"},on:{"click":_vm.printme}},[_c('i',{staticClass:"fas fa-print"}),_vm._v(" "+_vm._s(_vm.$t("PrintOfPDF"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }